import styled from 'styled-components'
import { Button } from '../../components/common/Button'

export const SubmitVanInfo = styled(Button)`
  width: 100%;
`
